import Button from 'components/Button';
import { shade } from 'polished';
import styled from 'styled-components';

export const Container = styled.div`
  padding: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;

  & > div {
    width: 100%;
  }
`;

export const ContentImage = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  margin: 30px 0;
  width: 100%;

  #mainContent {
    align-items: center;
    display: flex;
    flex-direction: column;
    width: 100%;
  }

  #contentInfo {
    background-color: #f3f8ff;
    width: 100%;
    border-radius: 8px;
    text-align: center;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin-top: 40px;
    padding: 16px;
  }

  #contentQrCode {
    width: 100%;
    max-width: 280px;
    display: flex;
    align-items: center;
    justify-content: center;

    margin: 10px 0;

    img {
      max-width: 250px;
      height: auto;
    }
  }

  button:first-child {
    color: #fff;
    background-color: #0c3bdd;
    border: 0;
    width: 242px;
    height: 48px;

    border-radius: 6px;
    transition: all 0.2s;

    font-size: 14px;

    :hover {
      background-color: ${shade(0.2, '#0C3BDD')};
      color: #fff;
    }
  }
`;

export const ContentInfo = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;

  width: 285px;
  height: 34px;

  #title {
    font-size: 24px;
    font-weight: bold;
    line-height: 38px;
  }

  #info {
    font-family: Nunito;
    font-weight: 400;
    font-size: 16px;
    line-height: 120%;
    letter-spacing: 0%;
    text-align: center;
  }
`;

export const ButtonSubmit = styled(Button)`
  width: 327px;
  height: 48px;
  background: #f3f8ff;
  border-radius: 8px;
  display: none;
  color: #000;

  @media screen and (max-width: 400px) {
    display: block;
  }

  svg {
    margin: 0 5px;
  }
`;

export const ContentErro = styled.div`
  width: 100%;
  height: 100vh;
  max-height: 400px;

  display: flex;
  flex-direction: column;

  align-items: center;
  justify-content: center;

  div {
    button {
      margin-top: 20px;
    }
  }
`;

export const ButtonGerarBoleto = styled.button`
  background: transparent;
  border-radius: 8px;
  border: 1px solid #f3f8ff;
  background-color: #076bee;

  width: 100%;
  height: 48px;

  display: flex;
  justify-content: center;
  align-items: center;

  transition: all 0.5s;

  :hover {
    background-color: ${shade(0.01, '#076bee')};
  }

  color: #f3f8ff;
  font-weight: bold;
  font-size: 14px;
  line-height: 14px;
`;
